import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_11'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_11',
  name: "Which of the following topics are included within the facility's written policies and procedures for foreign migrant workers?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'REFERENCE_TO_FOLLOWING_ALL_LOCAL_LAWS_FOR_RECRUITMENT_IN_BOTH_T',
      text: 'Reference to following all local laws for recruitment in both the sending and receiving countries',
      externalIds: [
        {
          id: 'ms-1--13-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RECRUITMENT_FEES_AND_EXPENSES',
      text: 'Recruitment fees and expenses',
      externalIds: [
        {
          id: 'ms-1--13-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMPLOYMENT_CONTRACTS',
      text: 'Employment contracts',
      externalIds: [
        {
          id: 'ms-1--13-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DEPOSITS',
      text: 'Deposits',
      externalIds: [
        {
          id: 'ms-1--13-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BANK_ACCOUNTS',
      text: 'Bank accounts',
      externalIds: [
        {
          id: 'ms-1--13-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HANDLING_OF_GOVERNMENT_ISSUED_IDENTIFICATION_DOCUMENTS',
      text: 'Handling of government-issued identification documents',
      externalIds: [
        {
          id: 'ms-1--13-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ACCOMMODATIONS',
      text: 'Accommodations',
      externalIds: [
        {
          id: 'ms-1--13-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARRIVAL_ORIENTATION',
      text: 'Arrival orientation',
      externalIds: [
        {
          id: 'ms-1--13-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FREEDOM_OF_MOVEMENT',
      text: 'Freedom of movement',
      externalIds: [
        {
          id: 'ms-1--13-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_IN_EMPLOYMENT',
      text: 'Non-discrimination in employment',
      externalIds: [
        {
          id: 'ms-1--13-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HARASSMENT_AND_ABUSE_IN_EMPLOYMENT',
      text: 'Harassment and abuse in employment',
      externalIds: [
        {
          id: 'ms-1--13-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DISCIPLINE_IN_EMPLOYMENT',
      text: 'Discipline in employment',
      externalIds: [
        {
          id: 'ms-1--13-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REPATRIATION_END_OF_EMPLOYMENT',
      text: 'Repatriation / end of employment',
      externalIds: [
        {
          id: 'ms-1--13-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EARLY_TERMINATION_OF_CONTRACT_BY_MIGRANT_WORKER',
      text: 'Early termination of contract by migrant worker',
      externalIds: [
        {
          id: 'ms-1--13-15x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'INVOLUNTARY_TERMINATION_OF_CONTRACT_BY_EMPLOYER',
      text: 'Involuntary termination of contract by employer',
      externalIds: [
        {
          id: 'ms-1--13-16x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REQUIREMENTS_FOR_LABOR_AGENTS_BROKERS',
      text: 'Requirements for labor agents/brokers',
      externalIds: [
        {
          id: 'ms-1--13-17x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--13-18x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--13-18f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'REFERENCE_TO_FOLLOWING_ALL_LOCAL_LAWS_FOR_RECRUITMENT_IN_BOTH_T',
                'RECRUITMENT_FEES_AND_EXPENSES',
                'EMPLOYMENT_CONTRACTS',
                'DEPOSITS',
                'BANK_ACCOUNTS',
                'HANDLING_OF_GOVERNMENT_ISSUED_IDENTIFICATION_DOCUMENTS',
                'ACCOMMODATIONS',
                'ARRIVAL_ORIENTATION',
                'FREEDOM_OF_MOVEMENT',
                'NON_DISCRIMINATION_IN_EMPLOYMENT',
                'HARASSMENT_AND_ABUSE_IN_EMPLOYMENT',
                'DISCIPLINE_IN_EMPLOYMENT',
                'REPATRIATION_END_OF_EMPLOYMENT',
                'EARLY_TERMINATION_OF_CONTRACT_BY_MIGRANT_WORKER',
                'INVOLUNTARY_TERMINATION_OF_CONTRACT_BY_EMPLOYER',
                'REQUIREMENTS_FOR_LABOR_AGENTS_BROKERS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-30',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 20050,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
